export default "__VITE_ASSET__CWjElmp5__"